import {Button, Stack, Typography, useTheme} from '@mui/material';
import React from 'react';

import {Container} from './styles';
import {CustomStepper} from '../CustomStepper';
import {StepContentProps} from './types';

function StepContent({
	buttonAction,
	buttonLabel,
	description,
	completed,
	footer,
	label,
}: StepContentProps) {
	const {palette} = useTheme();

	return (
		<Container StepIconComponent={CustomStepper}>
			<Stack flex={1}>
				<Typography variant="h6">{label}</Typography>
				<Stack gap={1} alignItems="flex-start">
					{description && completed ? (
						<Typography variant="body1" color={palette.text.secondary}>
							{description}
						</Typography>
					) : null}
					{completed ? footer : null}
				</Stack>
			</Stack>
			{buttonAction && completed ? (
				<Button variant="text" size="small" sx={{px: 1}} onClick={buttonAction}>
					{buttonLabel}
				</Button>
			) : null}
		</Container>
	);
}

export {StepContent};
